export const SERVICE_TYPES = {
  TRANSPORTE: 'TRANSPORTE',
  TREN: 'TREN',
  GUIA: 'GUIA',
  TICKET: 'TICKET',
  OPERADOR: 'OPERADOR',
  HOTELES: 'HOTELES',
  COORDINADOR: 'COORDINADOR'
};
